import { render } from "./VueSwitch.vue?vue&type=template&id=81753b7a&scoped=true"
import script from "./VueSwitch.vue?vue&type=script&lang=js"
export * from "./VueSwitch.vue?vue&type=script&lang=js"

import "./VueSwitch.vue?vue&type=style&index=0&id=81753b7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81753b7a"]])

export default __exports__